import { ReactElement } from 'react'
import { styled } from '@mui/material'

interface Props {
  background: string
  icon: ReactElement
}
export function WappIcon({ icon, background }: Props) {
  return <IconWrapper sx={{ background }}>{icon}</IconWrapper>
}

const IconWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  position: relative;
  svg {
    width: 22px;
    height: 22px;
    color: white;
  }
  path {
    fill: white;
  }
  flex-shrink: 0;
  ::before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    border: 1px solid rgb(0, 0, 0);
    opacity: 0.1;
    border-radius: 8px;
  }
`
